export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/mailchimp.d138d3eb.svg","height":69,"width":141,"blurWidth":0,"blurHeight":0};